<template>
  <div class="recruit" :style="mainStyle">
    <div class="recruit-wrapper">
      <div class="r-head">
        <div class="r-position">{{ recruits[recruitId].position }}</div>
        <div class="r-subtitle">发布时间：{{ recruits[recruitId].publishDate }}</div>
      </div>
      <div class="company">
        <span style="margin-right: 20px;">{{ recruits[recruitId].company }}</span>
        <div class="r-tab" v-for="(tab, index) in recruits[recruitId].tabs" :key="index">
          <img src="static/images/tab.png">
          <span>{{ tab }}</span>
        </div>
      </div>

      <div class="r-body">
        <div class="r-title">岗位职责</div>
        <div class="r-content">
          <pre style="font-size: 16px;">{{ recruits[recruitId].description }}</pre>
        </div>
        <div class="separator"></div>
        <div class="r-title">任职要求</div>
        <div class="r-content">
          <pre style="font-size: 16px;">{{ recruits[recruitId].requirement }}</pre>
        </div>
        <div class="r-title" v-show="recruits[recruitId].other !== undefined">补充说明</div>
        <div class="r-content">
          <pre style="font-size: 16px;">{{ recruits[recruitId].other }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    created() {
      let mainHeight = window.innerHeight - 108; // 总的高度 - footer的高度
      this.mainStyle['min-height'] = mainHeight + 'px';
    },
    data () {
      return {
        mainStyle: {
          'min-height': 'auto'
        },
        recruitId: this.$route.query.recruitid || '1',
        recruits: {
          1: {
            position: '广告平台运营',
            company: 'EK传媒',
            tabs: ['本科', '2年', '4k~8k'],
            publishDate: '2018-06-01',
            description: `1、主要服务于商业变现业务；
2、投放广告，统计数据，整理报表，跟进合同等综合性运营工作；
3、按测试用例以及业务需要，对产品质量的验证工作；
4、响应客户以及线上突发需求的计划外工作。`,
            requirement: `1、身体健康，性格积极，能够承担较大的工作压强；
2、熟悉office基本操作，熟悉windows基本操作；
3、踏实稳重，习惯大量重复性工作；
4、责任感强，执行力强，交待工作立即完成，不拖延过夜。`
          },
          2: {
            position: '后端广告算法工程师',
            company: 'EK传媒',
            tabs: ['本科', '2年', '10k~20k'],
            publishDate: '2018-06-05',
            description: `1. 完成广告算法/广告平台的开发编码工作；
2. 评估并输出算法模型的执行效果；`,
            requirement: `1. 计算机相关专业本科以上，1年以上工作经验；
2. 精通Python/Golang/Java等一门以上语言；
3.有Hadoop、Spark相关开发经验，熟悉Linux操作系统的相关知识；
4.熟悉MySQL的相关知识，有SQL调优经验；
5.有维护个人技术博客1年以上者优先；开发过DSP平台者优先`
          },
          3: {
            position: '商务',
            company: 'EK传媒',
            tabs: ['大专', '1年', '10k~20k'],
            publishDate: '2018-05-25',
            description: `1、负责在线上线下开拓市场，销售公司旗下新媒体业务； 
2、面向线上客户投放询价，为客户提供营销推广方案支持，服务好签约合作客户；
 3、跟进公司分配的项目，做好客情维护和业务拓展；`,
            requirement: `1、大专及以上学历；1年以上工作经验； 
2、对新媒体有一定的理解，对新媒体行业动态有浓厚的兴趣； 
3、有相关行业销售经验，有客户资源优先，比如广告主、广告推广渠道、媒体资源等； 
4、有较强的自我驱动力、学习能力与执行力。`,
            other: `薪资待遇：
高底薪+绩效+高额提成
1、一经录用即签订正式劳动合同，五险一金，周末、法定节假日正常休息。
2、享受员工旅游、节日福利、员工生日会、带薪培训等；
3、每年享受带薪年假、法定节假日、员工旅游、员工体检、丰富的员工活动；
4、广阔的职业提升空间，公平的晋升机制，完整的职前培训和在职培训；
5、公司处在高速发展阶段，所有员工享受公平晋升平台，能力决定薪资，实力决定岗位；
1、负责开拓有互联网广告投放需求的客户和广告主，包括电商、网服、移动互联网、游戏、金融、教育、本地商家等； 
2、负责在线上线下开拓市场，销售公司旗下新媒体业务;
3、完成各项服务工作，包括具体方案策略的制定和优质资源的推荐； 
4、对合作客户的投放效果负责，帮助客户实现利益最大化；
5、跟进公司分配的项目，做好客情维护和业务拓展；`
          },
          4: {
            position: 'app海外产品运营',
            company: '北京柏木科技',
            tabs: ['大专', '1年', '20k'],
            publishDate: '2018-06-01',
            description: `1.负责在海外推广GOMO产品，进行对外商务合作项目的商洽、推进，管理现有在线渠道，提升公司产品在所在领域的市场份额；
2.制定针对移动广告网络、应用商店和网盟等在线渠道合作策略，并实施拓展，保证执行和对结果负责；
3.负责收集目标市场移动互联网行业市场信息，分析竞争对手产品市场推广情况，提出更有效商务模式；
4.根据市场变化及时向产品提出有价值的建议和反馈。`,
            requirement: `1.从事无线 BD 工作两年以上，对海外无线推广有深刻的认识和广泛的资源；
2.有责任感，很强的计划、推动和执行力，具备优秀的英语表达能力；
3.工作积极主动，有强烈的责任心，乐于接受挑战，能很好的承担压力；
4.善于思考，逻辑思维缜密，有很强的学习能力；
5.对数据敏感，有较强的数据分析能力；
6.有独立把控和协调重要项目的能力；
7.在移动互联网某一细分领域有出色的推广或变现经验并有成功案例的工作经验者优先考虑；
8.有游戏商务及运营相关的工作经验者优先考虑；
9.熟悉facebook，adwords投放的优先。`,
          },
          5: {
            position: '商务经理-预装',
            company: '北京柏木科技',
            tabs: ['大专', '1年', '25k'],
            publishDate: '2018-05-05',
            description: `1. 针对自研产品与各大渠道进行合作与拓展工作； 
2. 完成日常的协议流程及数据核对等工作； 
3. 负责与合作伙伴确定推广方案，结合运营需求进行推广；
 4. 分析合作渠道的推广数据，及时反馈渠道推广合作中的各项问题，并妥善解决； 
5. 负责渠道商关系的开拓与维护，并与合作伙伴保持良好的合作关系和跟进工作（包括合作接入、对接跟进、后期维护。 `,
            requirement: `1. 一年以上无线互联网行业商务相关工作经验，统招本科及以上学历；
 2. 有良好的沟通协调、商务谈判能力，公关能力，能够承受较强的工作压力；
 3. 有推广及手机厂商等渠道成熟人脉者优先。`,
          },
          6: {
            position: 'iOS高级开发工程师',
            company: '纤寻科技',
            tabs: ['本科', '2年', '8k~15k'],
            publishDate: '2018-05-18',
            description: `1. 负责公司移动产品的研发, 编写高质量的代码
2. 根据产品需求完成架构和模块设计、编码、测试工作；
3. 能按照项目计划，按时提交高质量的代码，完成开发任务；
4. 负责iOS端APP项目代码的维护、性能调优以及版本更新迭代
5. 规范和文档的编写、维护。`,
            requirement: `1. 计算机相关专业，本科以上，2年iOS以上开发经验；
2 .良好的Objective-C/C++技术功底，熟悉面向对象软件设计思想，以及常见的设计模式；
3. 对iOS的运行时，内存管理，多线程，动画，事件循环，事件响应链，性能优化有深刻的理解；
4. 熟悉App内存占用、耗电、网络、UI渲染等性能方面分析和优化的方法
5. 数据结构、算法等基础知识扎实，有良好的编码风格和架构设计能力
6. 具有优秀的创新精神、钻研新技术的兴趣和能力，有较强的沟通能力、团队合作和高度的责任感；思维清晰、敏捷，能适应较大的工作压力。`,
          },
          7: {
            position: 'Android高级开发工程师',
            company: '纤寻科技',
            tabs: ['本科', '2年', '8k~15k'],
            publishDate: '2018-05-18',
            description: `1. 负责公司移动产品的研发, 编写高质量的代码
2. 根据产品需求完成架构和模块设计、编码、测试工作；
3. 能按照项目计划，按时提交高质量的代码，完成开发任务；
4. 负责Android端APP项目代码的维护、性能调优以及版本更新迭代
5. 规范和文档的编写、维护。`,
            requirement: `1. 计算机相关专业，本科以上，2年以上Android开发经验；
2. 良好的Java/ C/C++技术功底，熟悉面向对象软件设计思想，以及常见的设计模式；
3. 熟悉Android下网络通信机制，对Socket通信、TCP/IP和HTTP有较深刻的理解和经 验；
4. 熟练使用AndroidUI框架、后台运行、数据存储、网络通信等原理，熟悉Android内存管理机制，熟悉第三方控件，熟练使用AndroidStudio及相关调试工具；
5. 数据结构、算法等基础知识扎实，有良好的编码风格和架构设计能力
6. 具有优秀的创新精神、钻研新技术的兴趣和能力，有较强的沟通能力、团队合作和高度的责任感；思维清晰、敏捷，能适应较大的工作压力。`,
          },
          8: {
            position: '前端开发工程师',
            company: 'S.K.Y',
            tabs: ['本科', '1年', '8k~16k'],
            publishDate: '2018-03-23',
            description: `1.负责公司前端产品的功能开发与其他部门的功能协调； 
2.负责前端架构体系的规划、设计、建设； 
3.负责HTML5等前沿技术的研究。`,
            requirement: `1. 计算机相关专业本科及以上学历，1年以上前端开发经验；
2. 有扎实的前端技术基础，包括但不限于 HTML、CSS、JavaScript、DOM；
3. 熟悉常见的前端框架、库、工具，例如：jQuery、AngularJS、Backbone.js、React、Grunt、Gulp、D3、VueJS等；
4. 熟悉移动互联网应用开发环境，对于H5在各移动设备商的特性和应用有较丰富的经验；
5. 有大规模前端应用、大型网站前端优化经验者优先。`,
          },
          9: {
            position: '后端开发工程师',
            company: 'S.K.Y',
            tabs: ['本科', '2年', '15k~25k'],
            publishDate: '2018-04-20',
            description: `1、负责公司移动产品的服务端设计和开发；
2、接受不同技术领域的挑战： 如何让系统高效的承载千万用户的访问；如何让产品更快速地呈现在用户眼前；如何构建精准实时的推荐系统；如何对海量数据进行存储和扩展；
3、加入技术牛人团队，一起参与架构设计工作，承担核心功能研发；`,
            requirement: `1.计算机相关专业，本科及以上学历;2年以上工作经验； 
2.必须具备java，Nodejs，PHP中任意一种语言开发接口的能力； 
3.具备相当的sql编写能力，有sql优化经验尤佳; 
4.精通数据库原理，熟悉Greenplum，Postgresql、mysql等常见开源数据库的使用及性能优化; 
5.了解hadoop、spark，elasticsearch、kafka，python和bash等加分;
 6.工作积极主动，有责任心，具备良好的沟通能力和执行力.
`,
          },
          10: {
            position: '行政兼前台',
            company: 'S.K.Y',
            tabs: ['大专', '1年', '4k~6k'],
            publishDate: '2018-05-01',
            description: `1、接待来访客人并及时准确通知被访部门；
2、协助人事经理搜索简历，面试邀约；
3、每月日常物资采购，公司固定资产管理；
4、负责考勤系统的管理和登记，人员入职办理及资料归档；
5、领导交代的其他人事行政事务。`,
            requirement: `1、形象好，气质佳，年龄18—30岁；
2、大专及以上学历，1年以上相关工作经验；
3、优秀应届毕业生也可以；
4、具备良好的协调能力、沟通能力，富有责任心，性格活泼开朗，具有亲和力；
5、具备一定商务礼仪知识；
6、有意向往人力资源方向发展。`,
          },
          11: {
            position: '新媒体运营',
            company: '纤寻科技',
            tabs: ['大专', '2年', '5k~12k'],
            publishDate: '2018-05-03',
            description: `1、负责官方微博、微信、官方QQ等平台入口的用户客户客服以及日常内容的撰写和运营；
2、收集、研究网络热点话题，结合新媒体特性，对微博、微信内容的实时调整和更新；
3、负责微博、微信大型活动方案的策划、创意、执行、运营以及汇报和总结；
4、负责微博微信媒体资源拓展，渠道运营及管理；
5、分析同行业媒体内容结构及话题热点，调研目标用户群体喜好，在此基础上定位客户需求及喜好，增长分析量 ；
6、完成上级指定的其他工作；
`,
            requirement: `1、专科以上学历，2年以上工作经验；或者市场营销、广告、新闻传播、中文等相关专业本科以上学历；
2、有一定审美能力，和较强文案撰写与编辑能力，基本运用PS、美图秀秀等设计软件，懂得微博、微信图文排版修饰；
2、具有良好的沟通能力和执行力；
4、关注时下热点和时下年轻人的生活态度；有一定的创造力。`,
          },
          12: {
            position: '系统测试工程师',
            company: 'EK传媒',
            tabs: ['本科', '2年', '6k~10k'],
            publishDate: '2018-05-03',
            description: `1、负责移动互联网产品系统功能测试；

2、负责APP前后端系统性能测试设计，执行，分析；

3、根据业务需要，开发接口自动化和性能测试自动化工具；

4、提升自动化测试水平和测试相关建设水平。

`,
            requirement: `1、计算机相关专业，本科(含)以上学历
2、有互联网产品功能测试经验；
3，至少熟悉一门语言，Python、Java优先
4、能够使用抓包工具进行问题定位与分析
5、熟悉常用的测试工具，实现稳定性、性能、自动化或安全测试
6、熟悉数据库基本操作
7、具备2年以上移动端测试经验，熟悉Android、iOS应用软件测试方法
8、有大数据相关项目测试经验者优先
9、具备良好的需求理解和分析能力，能够快速理解业务，识别业务风险并给出优化方案。
10、热爱软件测试工作，对技术有兴趣、有激情，善于学习，善于分析，对待工作细致、认真、富有耐心，拥有良好的沟通能力以及团队合作精神，较强的责任感和进取精神。`,
          },
        }
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .recruit {
    padding-top: 40px;
    background-color: #f7fbfa;
    height: 100%;
    .recruit-wrapper {
      background-color: #ffffff;
      min-height: 200px;
      margin: 80px auto;
      padding: 0 20px;
      @media (min-width: 768px) {
        width: 100%;
      }
      @media (min-width: 800px) {
        width: 800px;
      }
      .r-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #666666;
        height: 60px;
        border-bottom: solid 2px #ebeef5;
        .r-position {
          background-color: #409EFF;
          padding: 0 20px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          color: #ffffff;
          margin-top: -20px;
          font-size: 20px;
        }
        .r-subtitle {
          font-size: 14px;
        }
      }
      .company {
        color: #333333;
        display: flex;
        align-items: center;
        .r-tab {
          margin-left: 10px;
          img {
            width: 16px;
            vertical-align: middle;
          }
          span {
            color: #666666;
            font-size: 14px;
          }
        }
      }
      .r-body {
        padding: 40px 0;
      }
      .r-title {
        border-left: solid 6px #409EFF;
        padding-left: 10px;
        margin-bottom: 20px;
        font-size: 20px;
        color: #333333;
      }
      .r-content {
        color: #666666;
        line-height: 28px;
      }
      .separator {
        width: 100%;
        border-top: solid 1px #ebeef5;
        margin: 40px 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/recruit/recruit.vue